<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    :append-to-body="true"
    :custom-class="`view-role-container ${zsTjTheme}`"
    width="480px"
    @close="handleClose"
  >
    <template #title>
      <div class="modal-title">{{ current.name || "角色信息" }}</div>
    </template>
    <div
      :class="[
        'role-content',
        { 'flex-center': current.type === 'pet' || !current.currentPotential || !current.currentPotential.length }
      ]"
    >
      <div class="tab-wrapper">
        <div
          v-for="(role, index) in tabList"
          :key="role.v4"
          :class="['tab-item', role.v4 === current.v4 ? 'tab-item-active' : 'tab-item-inavtive']"
          @click="current = role"
        >
          <div :class="['avatar-wrapper', getItemBg(role)]">
            <img :src="role.cover_url" alt="" />
            <div
              v-if="
                role.currentStrengthen &&
                  role.currentStrengthen.name &&
                  strengthArr.includes(role.currentStrengthen.name)
              "
              class="strenth-icon"
            >
              <img :src="getStrenthUrl(role.currentStrengthen.name)" alt="" />
            </div>
            <div class="bottom-info">
              {{ role.currentSkin ? role.currentSkin.name : role.name }}
            </div>
          </div>
          <div
            :class="['bottom-text', index === 0 ? 'recommend' : '', role.v4 === current.v4 ? 'bottom-text-active' : '']"
          >
            {{ index === 0 ? "最佳推荐" : "下位替补" }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="current.currentPotential && current.currentPotential.length" class="des-box">
      <div class="caption" style="margin-bottom:20px 0 15px;">技能潜力</div>
      <div v-for="item in current.currentPotential" :key="item.name" class="line">
        <img :src="item.icon" alt="" />
        <span v-if="item.desc" class="desc">{{ item.desc }}</span>
        <img v-if="!item.desc && item.image" :src="item.image" alt="" />
      </div>
    </div>
    <template v-if="current.type === 'role'">
      <template v-if="current.currentStrengthen">
        <div class="caption" style="margin: 28px 0 15px;">技能说明</div>
        <div class="info-box">
          <div class="left-skill">
            <div class="skill-title">技能范围</div>
            <img class="skill-img" :src="current.currentStrengthen.image" alt="" />
          </div>
          <div class="right-des">
            <div class="top-des">
              <span>SP: {{ current.currentStrengthen.sp }}</span>
              <span>CD: {{ current.currentStrengthen.cd }}</span>
            </div>
            <div class="des-content">
              {{ current.currentStrengthen.desc }}
            </div>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="caption" style="margin: 28px 0 15px;">技能说明</div>
      <div class="info-box">
        <div class="left-skill">
          <div class="skill-title">技能范围</div>
          <img v-if="current.skill_image" class="skill-img" :src="current.skill_image" alt="" />
        </div>
        <div class="right-des">
          <div class="top-des">
            <span>{{ current.skill_name }}</span>
          </div>
          <div class="des-content">
            {{ current.skill_desc }}
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    currentShowRoleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      current: {},
      tabList: [],
      visible: false,
      strengthArr: ["+1", "+2", "+3", "+4", "+5", "满破满潜力"]
    };
  },
  computed: {
    ...mapGetters(["zsTjTheme"])
  },
  watch: {
    currentShowRoleData(object) {
      let backup1 = object.backup1;
      let backup2 = object.backup2;
      this.current = object;
      this.tabList = [object, backup1, backup2].filter(Boolean);
    }
  },
  methods: {
    // 获取背景
    getItemBg(data) {
      if (data.attr === "火") {
        return "red";
      } else if (data.attr === "光") {
        return "yellow";
      } else if (data.attr === "水") {
        return "blue";
      } else if (data.attr === "暗") {
        return "purple";
      } else if (data.attr === "风") {
        return "green";
      }
      return "";
    },
    // 获取强化图标
    getStrenthUrl(name) {
      if (name === "满破满潜力") {
        return require(`@/assets/zs_imgs/battle/strenth_full.webp`);
      }
      return require(`@/assets/zs_imgs/battle/strenth${name}.webp`);
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>
<style lang="less" scoped>
@import "~@/views/wiki/battle/components/common.less";

/deep/ .view-role-container {
  background: linear-gradient(180deg, #effcff, #fff);
  border: 1px solid #ddd6ce;
  border-radius: 8px;
  .el-dialog__header {
    background: rgba(0, 0, 0, 0.15);
    padding-bottom: 14px;
    margin-bottom: 0;
    box-sizing: content-box;
    color: #333;
    font-size: 16px;
    font-weight: 500;
    .el-dialog__headerbtn i {
      color: #333;
    }
  }
  .el-dialog__body {
    background-color: rgba(120, 165, 211, 0.06);
    .caption {
      color: #333;
      background-color: rgba(166, 171, 183, 0.3);
    }
    .des-box .line {
      border-bottom-color: rgba(0, 0, 0, 0.15);
      .desc {
        color: #333;
        font-size: 14px;
      }
    }
    .info-box {
      .left-skill {
        background-color: rgba(141, 151, 162, 0.2);
        .skill-title {
          color: #333;
          font-size: 13px;
          background-color: rgba(85, 125, 156, 0.19);
        }
      }
      .right-des {
        .top-des span {
          color: #ff6600;
        }
        .des-content {
          font-size: 14px;
          color: #333;
        }
      }
    }
    .role-content {
      border-bottom-color: rgba(0, 0, 0, 0.15);
      .tab-wrapper {
        .tab-item {
          .bottom-text {
            color: #333;
            background-color: rgba(166, 171, 183, 0.4);
          }
          .bottom-text-active::before {
            border-color: #333;
            border-right-color: transparent;
            border-bottom-color: transparent;
          }
          .bottom-text-active::after {
            background-color: #333;
          }
          .recommend {
            background: url("~@/assets/zs_imgs/zbtj/star-mini-black.png") left 6px center / 9px 9px no-repeat,
              url("~@/assets/zs_imgs/zbtj/star-mini-black.png") right 6px center / 9px 9px no-repeat;
            background-color: rgba(166, 171, 183, 0.4);
            color: #333;
          }
        }
        .tab-item-active {
          background: linear-gradient(180deg, #c3cad6 0%, rgba(223, 225, 233, 0) 100%);
        }
      }
    }
  }
}
.caption {
  line-height: 36px;
  text-align: center;
  color: #ccc;
  font-size: 12px;
  background: rgba(166, 171, 183, 0.3);
  border-radius: 4px;
}
.modal-title {
  text-align: center;
}
.role-content {
  margin-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  .tab-wrapper {
    display: flex;
    justify-content: center;
    .tab-item {
      position: relative;
      width: fit-content;
      box-sizing: content-box;
      padding: 18px 18px 15px;
      height: 150px;
      cursor: pointer;
      .avatar-wrapper {
        width: 96px;
        height: 120px;
        position: relative;
        border-radius: 8px;
        .strenth-icon {
          position: absolute;
          right: 0px;
          top: 0px;
          width: 38px;
          height: 30px;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        img {
          width: 100%;
          height: 100%;
          border-radius: 4px;
          object-fit: cover;
        }
        .bottom-info {
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          bottom: 0;
          left: 0;
          right: 0;
          height: 24px;
          color: #fff;
          font-size: 12px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
          border-radius: 0 0 8px 8px;
        }
      }
      .bottom-text {
        width: 96px;
        line-height: 22px;
        text-align: center;
        font-size: 12px;
        border-radius: 20px;
        color: #999;
        background-color: #1c1e21;
        margin-top: 7px;
      }
      .bottom-text-active {
        &::before {
          content: "";
          position: absolute;
          width: 0;
          height: 0;
          border: 4px solid #fff;
          border-right-color: transparent;
          border-bottom-color: transparent;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%) rotate(45deg);
        }
        &::after {
          content: "";
          position: absolute;
          width: 96px;
          height: 2px;
          background-color: #fff;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
      .recommend {
        background: url("~@/assets/zs_imgs/zbtj/star-mini-yellow.png") left 6px center / 9px 9px no-repeat,
          url("~@/assets/zs_imgs/zbtj/star-mini-yellow.png") right 6px center / 9px 9px no-repeat;
        background-color: #1c1e21;
        color: #c0a078;
      }
    }
    .tab-item-inavtive {
      opacity: 0.5;
    }
    .tab-item-inavtive::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: rgba(0, 0, 0, 0);
    }
  }
}

.des-box {
  display: flex;
  flex-direction: column;
  .line {
    display: flex;
    align-items: center;
    height: 44px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    &:last-child {
      border-bottom: none;
    }
    img {
      flex: 0 0 auto;
      width: 28px;
      height: 28px;
      margin-right: 10px;
    }
    .desc {
      flex: 1;
      color: #fff;
      font-size: 12px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.info-box {
  display: flex;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  column-gap: 17px;
  .left-skill {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 16px;
    box-sizing: content-box;
    padding: 2px 2px 7px;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.13);
    .skill-title {
      width: 88px;
      color: #ccc;
      font-size: 13px;
      line-height: 24px;
      font-weight: 400;
      text-align: center;
      background-color: rgba(99, 104, 134, 0.19);
    }
    img {
      width: 60px;
      height: 60px;
      object-fit: cover;
    }
  }
  .right-des {
    flex: 1;
    .top-des {
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        margin-right: 30px;
        color: #ffc982;
        font-size: 14px;
        font-weight: 500;
        line-height: 21px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .des-content {
      color: #fff;
      font-size: 12px;
      font-weight: 400;
    }
  }
}
</style>
